import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Panel, Button, Col, Row } from 'react-bootstrap';
import { Input, DateTimeInput, FormActions } from '../../common/components/formControls';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, onReset, initialize, loading, documentCategories, t }) => {
	const handleReset = () => {
		initialize({});
		onReset();
	};
	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit}>
					<Row>
						<Col sm={6}>
							<Field name='documentCategory' component={Input} componentClass='select' label={t('DocumentForm_Category')} >
								<option />
								{ui.makeOptionValues(documentCategories)}
							</Field>
						</Col>
						<Col sm={6}>
							<Field name='name' component={Input} label={t('DocumentForm_Name')} />
						</Col>
					</Row>
					<FormActions>
						<Button type='submit' disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<Button disabled={loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'documentFormsFilter' })(withTranslation()(Filter));